/* __next_internal_client_entry_do_not_use__ HoverItem auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";
var linkColor = Core.text.subdued;
var linkHoverColor = Core.text.default;
var HoverChild = styled.div.withConfig({
    componentId: "sc-f59d3aa2-0"
})([
    "display:none;"
]);
var Item = styled(Row).attrs(function() {
    return {
        align: "center",
        justify: "center"
    };
}).withConfig({
    componentId: "sc-f59d3aa2-1"
})([
    "",
    ";color:",
    ";height:60px;padding:0 12px;cursor:pointer;transition:color 0.1s linear;white-space:nowrap;&:hover{color:",
    ";}",
    "{height:50px;}"
], TypographyStyles({
    as: undefined
}), linkColor, linkHoverColor, responsiveMediaQueries.mobile);
var ItemForFooter = styled(Item).withConfig({
    componentId: "sc-f59d3aa2-2"
})([
    "height:30px;",
    "{height:40px;}"
], responsiveMediaQueries.mobile);
var HoverItemContainer = styled.div.withConfig({
    componentId: "sc-f59d3aa2-3"
})([
    "&:hover{",
    "{display:block;}}"
], HoverChild);
export var HoverItem = function(_param) {
    var hoverChild = _param.hoverChild, position = _param.position, children = _param.children, rest = _object_without_properties(_param, [
        "hoverChild",
        "position",
        "children"
    ]);
    var ItemWrapper = position === "top" ? ItemForFooter : Item;
    return /*#__PURE__*/ _jsxs(HoverItemContainer, _object_spread_props(_object_spread({}, rest), {
        children: [
            /*#__PURE__*/ _jsx(ItemWrapper, {
                children: children
            }),
            /*#__PURE__*/ _jsx(HoverChild, {
                children: hoverChild
            })
        ]
    }));
};
